import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count", "form", "idsField"]

  connect() {
    this.injectSelectAllCheckbox()
  }

  injectSelectAllCheckbox() {
    const headerCell = this.element.querySelector("th.data-table-checkbox-col")
    if (!headerCell || headerCell.querySelector("input")) return

    const cb = document.createElement("input")
    cb.type = "checkbox"
    cb.className = "bulk-select-checkbox"
    cb.dataset.bulkSelectTarget = "selectAll"
    cb.dataset.action = "change->bulk-select#toggleAll"
    headerCell.textContent = ""
    headerCell.appendChild(cb)
  }

  toggle() {
    this.syncSelectAll()
    this.updateBar()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.visibleCheckboxes().forEach(cb => cb.checked = checked)
    this.updateBar()
  }

  updateBar() {
    const selected = this.selectedIds()
    const count = selected.length

    if (count > 0) {
      this.barTarget.hidden = false
      this.countTarget.textContent = `${count} selected`
      this.idsFieldTarget.value = selected.join(",")
    } else {
      this.barTarget.hidden = true
    }
  }

  selectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked && !cb.closest("tr[hidden]"))
      .map(cb => cb.value)
  }

  visibleCheckboxes() {
    return this.checkboxTargets.filter(cb => !cb.closest("tr[hidden]"))
  }

  syncSelectAll() {
    const visible = this.visibleCheckboxes()
    if (!this.hasSelectAllTarget || visible.length === 0) return
    this.selectAllTarget.checked = visible.every(cb => cb.checked)
  }
}
